import { motion } from "framer-motion";

import { CheckoutForm } from "@/modules/checkout";
import { GiftCardMultiPreview } from "@/modules/giftCards";
import { Models } from "api/types";

type GiftCardCheckoutContainerProps = {
  platform: Models<"PlatformModel">;
  cartDetails: Models<"ShopDisplayOrderResult"> | null;
  transactionDetails: Models<"InitiateOrderTransactionResult"> | null;
  user: Models<"UserModel1"> | null;
  transfers: Models<"DisplayGiftCardTransferItem">[];
};

export const GiftCardCheckoutContainer = ({
  cartDetails,
  transactionDetails,
  user,
  platform,
  transfers,
}: GiftCardCheckoutContainerProps) => {
  const cartItems = cartDetails?.shopDisplayOrderLineItems || [];

  const cards = cartItems.map((item) => {
    const transfer = transfers?.find(
      (transfer) => transfer.id === item.packageTransferId
    );

    return {
      imageUrl: item.imageUrl ?? "",
      cost: item.cost ?? 0,
      name: item.name ?? "",
      recipientInformation: transfer?.recipientInformation ?? "",
      senderInformation: transfer?.senderInformation ?? "",
      logoImageUrl: platform.logoImageUrl ?? "",
    };
  });

  return (
    <div className="GiftCardCheckoutContainer relative flex h-auto min-h-[calc(100vh-64px)] flex-col overflow-hidden lg:h-[calc(100vh-64px)] lg:flex-row">
      <motion.div
        className="top-0 hidden items-center justify-center bg-brand-color/5 lg:sticky lg:flex lg:h-screen lg:w-1/2 lg:flex-1"
        initial={{ opacity: 0, x: 0 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeInOut", delay: 0.4 }}
      >
        <GiftCardMultiPreview cards={cards} />
      </motion.div>
      <motion.div
        className="flex flex-1 justify-center bg-white p-2 lg:h-full lg:overflow-y-auto lg:p-6"
        initial={{ opacity: 0, x: 0 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeInOut", delay: 0.2 }}
      >
        <div className="flex w-full flex-col justify-center py-4 sm:max-w-xl">
          <CheckoutForm
            cartDetails={cartDetails as Models<"ShopDisplayOrderResult">}
            platform={platform}
            user={user as Models<"UserModel1">}
            transactionDetails={transactionDetails}
            redirectBaseUrl={"/gift-cards/success"}
            refreshUrl={"/gift-cards/cart"}
            isGiftCardLayout
          />
        </div>
      </motion.div>
    </div>
  );
};
